<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('Add/Remove to cart') }}</span>
      </v-card-title>
      <v-card-text>
        <label>{{ $t('Options') }}</label>
        <div class="form-control" :class="{ 'has-error': errors.has('method') }">
          <v-radio-group
            :data-vv-as="$t('Method')"
            name="method"
            row
            v-model="optype"
            v-validate="'required'"
          >
            <v-radio color="primary" :value="'addtocart'" :label="$t('Add')"></v-radio>
            <v-radio color="primary" :value="'removetocart'" :label="$t('Remove')"></v-radio>
            <v-radio
              color="primary"
              :value="'removeandaddtocart'"
              :label="$t('Clear&Add')"
            ></v-radio>
          </v-radio-group>
          <span class="text-error" v-if="errors.has('method')">{{ errors.first('method') }}</span>
        </div>
        <div v-for="(item, k) in items" :key="k">
          <v-card>
            <v-card-text style="position: relative">
              <div class="text-xs-right">
                <v-btn
                  @click="items.splice(k, 1)"
                  small
                  icon
                  style="position: absolute; right: 0; top: 0"
                >
                  <span class="material-icons">delete_outline</span>
                </v-btn>
              </div>
              <div :style="{ 'min-height': expandForSelect === k ? '300px' : '' }">
                <div class="form-control" :class="{ 'has-error': errors.has('product') }">
                  <label>{{ $t('Products') }}</label>

                  <multiselect
                    v-validate="'required'"
                    :data-vv-as="$t('Product')"
                    :placeholder="$t('Select Product')"
                    name="product"
                    v-model="item.pid"
                    @select="onSelectedProduct(k)"
                    :options="filterProducts"
                    @open="expandForSelect = k"
                    @close="expandForSelect = ''"
                    return="id"
                    label="name"
                    :maxHeight="250"
                    :openDirection="'below'"
                    :close-on-select="true"
                  ></multiselect>
                  <span class="text-error" v-if="errors.has('product')">{{
                    errors.first('product')
                  }}</span>
                </div>
                <v-layout row rows wrap>
                  <v-flex xs12 lg7 style="padding-right: 5px">
                    <div class="form-control" :class="{ 'has-error': errors.has('option') }">
                      <label>{{ $t('stock') }}</label>
                      <multiselect
                        name="option"
                        :data-vv-as="$t('Options')"
                        v-validate="'required'"
                        v-model="item.option"
                        :options="$options.filters.filteredStock(item)"
                        @open="expandForSelect = k"
                        @close="expandForSelect = false"
                        :placeholder="$t('Select Stock')"
                        :maxHeight="250"
                        :openDirection="'below'"
                        :close-on-select="true"
                      ></multiselect>
                      <span class="text-error" v-if="errors.has('option')">{{
                        errors.first('option')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 lg3>
                    <div class="form-control" :class="{ 'has-error': errors.has('quantity') }">
                      <label>{{ $t('quantity') }}</label>
                      <input
                        v-validate="'required'"
                        type="text"
                        name="quantity"
                        :data-vv-as="$t('quantity')"
                        v-model="item.qty"
                        @keypress="isNumber($event, item.qty)"
                      />
                      <span class="text-error" v-if="errors.has('quantity')">{{
                        errors.first('quantity')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex v-if="$store.getters.getPackage == 'premium'" lg2>
                    <IntentPrefillCartAddRemove
                      @show=";['Number']"
                      @onAddPrefill="onAddPrefill($event, item)"
                    ></IntentPrefillCartAddRemove>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="text-xs-right">
          <v-btn @click="additem" flat color="green">
            <span class="material-icons">add</span>
            {{ $t('Add product') }}
          </v-btn>
        </div>
        <div class="text-xs-center mt-2">
          <v-btn @click="close" outline color="grey">CANCEL</v-btn>

          <v-btn v-if="data" @click="update" depressed color="primary">UPDATE</v-btn>
          <v-btn v-else @click="save" depressed color="primary">SAVE</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import multiselect from 'vue-multiselect'
import IntentPrefillCartAddRemove from '@/components/elements/IntentPrefillCartAddRemove.vue'

export default {
  props: ['data'],
  data() {
    return {
      optype: '',
      loading: false,
      expandForSelect: false,
      items: [
        {
          qty: '',
          pid: '',
          option: '',
        },
      ],
    }
  },
  components: {
    multiselect,
    IntentPrefillCartAddRemove,
  },
  mounted() {
    if (this.data) {
      this.optype = this.data.type
      this.product = this.products.filter((el) => el.id == this.data.pid)[0]
      this.items = this.data.input
      this.items = this.items.map((el) => {
        return { ...el, pid: this.products.find((val) => val.id == el.pid) }
      })
    }
  },
  computed: {
    filterProducts() {
      return this.products
    },
    // filterStocks() {
    //   if (this.product) {
    //     return this.product.productstock.map(el => el[1])
    //   } else {
    //     return []
    //   }
    // },
    ...mapGetters({ products: 'getProducts' }),
  },
  methods: {
    isNumber: function (evt, qty) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) ||
        !/^[0-9]*$/gm.test(qty)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onAddPrefill(v, item) {
      item.qty = v
    },
    additem() {
      this.items.push({
        option: '',
        pid: '',
        qty: '',
      })
    },
    update() {
      var data = this.items.map((el) => {
        return { pid: el.pid.id, qty: el.qty, option: el.option }
      })
      this.$emit('updateRemoveAndAdd', {
        type: this.optype,
        data: data,
        index: this.data.index,
      })
      this.close()
    },
    close() {
      this.optype = ''
      this.stock = ''
      this.product = ''
      this.quantity = ''
      this.$emit('close')
    },
    save() {
      var vm = this
      // var data = {
      //   pid: this.product.id,
      //   qty: this.quantity,
      //   option: this.stock
      // }
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }
        var data = vm.items.map((el) => {
          return { pid: el.pid.id, qty: el.qty, option: el.option }
        })
        vm.$emit('addIntentItem', vm.optype, data)
        vm.close()
      })
    },
    onSelectedProduct(k) {
      this.items[k].option = ''
    },
  },
  filters: {
    filteredStock: function (value) {
      if (value && value.pid) {
        return value.pid.productstock.map((el) => el[1])
      } else {
        return []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentCartAddRemove.vue